module.exports = __webpack_public_path__ + "img/img6.0ab5b930.jpg";